import adapter from '../adapter-forum-post';
var IDs = adapter.IDs, SchemaTypes = adapter.SchemaTypes;
export default {
    type: SchemaTypes.FORUM_POST_DISCUSSION,
    schema: {
        '@context': 'https://schema.org',
        '@type': 'DiscussionForumPosting',
        mainEntityOfPage: "{{".concat(IDs.PAGE_URL, "}}"),
        headline: "{{".concat(IDs.TITLE, "}}"),
        text: "{{".concat(IDs.CONTENT_FULL, "}}"),
        url: "{{".concat(IDs.PAGE_URL, "}}"),
        author: {
            '@type': 'Person',
            name: "{{".concat(IDs.AUTHOR, "}}"),
            url: "{{".concat(IDs.AUTHOR_PROFILE_URL, "}}"),
        },
        datePublished: "{{".concat(IDs.PUBLISH_DATE, "}}"),
        interactionStatistic: {
            '@type': 'InteractionCounter',
            interactionType: 'https://schema.org/LikeAction',
            userInteractionCount: "{{".concat(IDs.LIKE_AMOUNT, "}}"),
        },
        comment: "{{".concat(IDs.LAST_FIVE_COMMENTS, "}}"),
    },
};
